/**
 * Stable activity KEY for Risk Masters, matching the seeded catalogue
 * (migration 122 — USR_activities.activity_key = 'RSK_MASTERS').
 *
 * Frontend permission checks resolve grants from /api/v1/usr/permissions/me by
 * this key. Renaming the activity label never breaks this — the key is stable.
 */

export const RBAC_ACTIVITY = 'RSK_MASTERS';
